export class SupportChat {
  private static readonly chatDomId = '#hubspot-messages-iframe-container';

  static loadChat(): boolean {
    if (!window.HubSpotConversations?.widget) return false;

    window.HubSpotConversations.widget.load();
    return true;
  }

  static removeChat(): boolean {
    if (!window.HubSpotConversations?.widget) return false;

    window.HubSpotConversations.widget.remove();
    return true;
  }

  static chatDomEl(): HTMLElement | null {
    return document.querySelector(this.chatDomId);
  }

  static isChatLoaded(): boolean {
    return Boolean(this.chatDomEl());
  }

  static openChat(): void {
    window.HubSpotConversations.widget.open();
  }
}
